export default __webpack_public_path__ + "static/experienceImg2-4d08c973b10e84a4621161add122a548.webp";